import { useMemo } from 'react'
import { selectShopBoardForDisplay } from '../redux/shop/selectors'
import { useAppSelector } from '../redux/store'

export function useShopPatientIds() {
  const orders = useAppSelector((state) => selectShopBoardForDisplay(state).orders)

  return useMemo(() => new Set(orders.map((order) => order.patientId)), [orders])
}
